import svgIcon from '@Components/svg-icon/svg-icon.cmp.js';

let mod = angular
	.module('toastr', [svgIcon])
	.constant('toastrConfig', {
		allowHtml: true,
		autoDismiss: false,
		closeButton: false,
		closeHtml: '<button>&times;</button>',
		containerId: 'toast-container',
		extendedTimeOut: 1000,
		iconClasses: {
			error: 'toast-error',
			info: 'toast-info',
			success: 'toast-success',
			warning: 'toast-warning',
		},
		iconNames: {
			error: 'x-circle-fill',
			info: 'info-circle-fill',
			success: 'check-circle-fill',
			warning: 'exclamation-triangle-fill',
		},
		maxOpened: 0,
		messageClass: 'toast-message',
		newestOnTop: true,
		onHidden: null,
		onShown: null,
		onTap: null,
		positionClass: 'toast-top-right',
		preventDuplicates: false,
		preventOpenDuplicates: false,
		progressBar: false,
		tapToDismiss: true,
		target: 'body',
		templates: {
			toast: 'directives/toast/toast.html',
			progressbar: 'directives/progressbar/progressbar.html',
		},
		timeOut: 5000,
		titleClass: 'toast-title',
		toastClass: 'toast zindex-toast',
	})
	.directive('progressBar', progressBar)
	.controller('ToastController', ToastController)
	.directive('toastDrt', directiveToast)
	.factory('toastr', factoryToastr);

function factoryToastr($animate, $injector, $rootScope, $sce, toastrConfig, $q) {
	var container;
	var index = 0;
	var toasts = [];

	var previousToastMessage = '';
	var openToasts = {};

	var containerDefer = $q.defer();

	var toast = {
		active: active,
		clear: clear,
		error: error,
		info: info,
		remove: remove,
		success: success,
		warning: warning,
		refreshTimer: refreshTimer,
	};

	return toast;

	/* Public API */
	function active() {
		return toasts.length;
	}

	function clear(toastItem) {
		// Bit of a hack, I will remove this soon with a BC
		if (arguments.length === 1 && !toastItem) {
			return;
		}

		if (toastItem) {
			remove(toastItem.toastId);
		} else {
			for (var i = 0; i < toasts.length; i++) {
				remove(toasts[i].toastId);
			}
		}
	}

	function error(message, title, optionsOverride) {
		var type = _getOptions().iconClasses.error;
		return _buildNotification(type, message, title, optionsOverride);
	}

	function info(message, title, optionsOverride) {
		var type = _getOptions().iconClasses.info;
		return _buildNotification(type, message, title, optionsOverride);
	}

	function success(message, title, optionsOverride) {
		var type = _getOptions().iconClasses.success;
		return _buildNotification(type, message, title, optionsOverride);
	}

	function warning(message, title, optionsOverride) {
		var type = _getOptions().iconClasses.warning;
		return _buildNotification(type, message, title, optionsOverride);
	}

	function refreshTimer(toastItem, newTime) {
		if (toastItem && toastItem.isOpened && toasts.indexOf(toastItem) >= 0) {
			toastItem.scope.refreshTimer(newTime);
		}
	}

	function remove(toastId, wasClicked) {
		var toastItem = findToast(toastId);

		if (toastItem && !toastItem.deleting) {
			// Avoid clicking when fading out
			toastItem.deleting = true;
			toastItem.isOpened = false;
			$animate.leave(toastItem.el).then(function () {
				if (toastItem.scope.options.onHidden) {
					toastItem.scope.options.onHidden(!!wasClicked, toastItem);
				}
				toastItem.scope.$destroy();
				var toastIdx = toasts.indexOf(toastItem);
				delete openToasts[toastItem.scope.message];
				toasts.splice(toastIdx, 1);
				var maxOpened = toastrConfig.maxOpened;
				if (maxOpened && toasts.length >= maxOpened) {
					toasts[maxOpened - 1].open.resolve();
				}
				if (lastToast()) {
					container.remove();
					container = null;
					containerDefer = $q.defer();
				}
			});
		}

		function findToast(id) {
			for (var i = 0; i < toasts.length; i++) {
				if (toasts[i].toastId === id) {
					return toasts[i];
				}
			}
		}

		function lastToast() {
			return !toasts.length;
		}
	}

	/* Internal functions */
	function _buildNotification(type, message, title, optionsOverride) {
		var resolvedTitle = title;
		var resolvedOverride = optionsOverride;
		if (typeof resolvedTitle === 'object' && resolvedTitle !== null) {
			resolvedOverride = resolvedTitle;
			resolvedTitle = null;
		}

		return _notify({
			iconClass: type,
			message: message,
			optionsOverride: resolvedOverride,
			title: resolvedTitle,
		});
	}

	function _getOptions() {
		return Object.assign({}, toastrConfig);
	}

	function _createOrGetContainer(options) {
		if (container) {
			return containerDefer.promise;
		}

		container = angular.element('<div></div>');
		container.attr('id', options.containerId);
		container.addClass(options.positionClass);
		container.css({'pointer-events': 'auto'});

		var target = angular.element(document.querySelector(options.target));

		if (!target || !target.length) {
			throw new Error("Target for toasts doesn't exist");
		}

		$animate.enter(container, target).then(function () {
			containerDefer.resolve();
		});

		return containerDefer.promise;
	}

	function _notify(map) {
		var options = _getOptions();

		if (shouldExit()) {
			return;
		}

		var newToast = createToast();

		toasts.push(newToast);

		if (ifMaxOpenedAndAutoDismiss()) {
			var oldToasts = toasts.slice(0, toasts.length - options.maxOpened);
			for (var i = 0, len = oldToasts.length; i < len; i++) {
				remove(oldToasts[i].toastId);
			}
		}

		if (maxOpenedNotReached()) {
			newToast.open.resolve();
		}

		newToast.open.promise.then(function () {
			_createOrGetContainer(options).then(function () {
				newToast.isOpened = true;
				if (options.newestOnTop) {
					$animate.enter(newToast.el, container).then(function () {
						newToast.scope.init();
					});
				} else {
					var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
					$animate.enter(newToast.el, container, sibling).then(function () {
						newToast.scope.init();
					});
				}
			});
		});

		return newToast;

		function ifMaxOpenedAndAutoDismiss() {
			return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
		}

		function createScope(toastItem, notifyMap, toastOptions) {
			if (toastOptions.allowHtml) {
				toastItem.scope.allowHtml = true;
				toastItem.scope.title = $sce.trustAsHtml(notifyMap.title);
				toastItem.scope.message = $sce.trustAsHtml(notifyMap.message);
			} else {
				toastItem.scope.title = notifyMap.title;
				toastItem.scope.message = notifyMap.message;
			}

			toastItem.scope.toastType = toastItem.iconClass;
			toastItem.scope.toastId = toastItem.toastId;
			toastItem.scope.extraData = toastOptions.extraData;

			toastItem.scope.options = {
				extendedTimeOut: toastOptions.extendedTimeOut,
				messageClass: toastOptions.messageClass,
				onHidden: toastOptions.onHidden,
				onShown: generateEvent('onShown'),
				onTap: generateEvent('onTap'),
				progressBar: toastOptions.progressBar,
				tapToDismiss: toastOptions.tapToDismiss,
				timeOut: toastOptions.timeOut,
				titleClass: toastOptions.titleClass,
				toastClass: toastOptions.toastClass,
			};

			if (toastOptions.closeButton) {
				toastItem.scope.options.closeHtml = toastOptions.closeHtml;
			}

			function generateEvent(event) {
				if (toastOptions[event]) {
					return function () {
						toastOptions[event](toastItem);
					};
				}
			}
		}

		function createToast() {
			var toastInstance = {
				toastId: index++,
				isOpened: false,
				scope: $rootScope.$new(),
				open: $q.defer(),
			};
			toastInstance.iconClass = map.iconClass;
			if (map.optionsOverride) {
				Object.assign(options, cleanOptionsOverride(map.optionsOverride));
				toastInstance.iconClass = map.optionsOverride.iconClass || toastInstance.iconClass;
			}

			createScope(toastInstance, map, options);

			toastInstance.el = createToastEl(toastInstance.scope);

			return toastInstance;

			function cleanOptionsOverride(overrideOptions) {
				var badOptions = [
					'containerId',
					'iconClasses',
					'maxOpened',
					'newestOnTop',
					'positionClass',
					'preventDuplicates',
					'preventOpenDuplicates',
					'templates',
				];
				for (var b = 0, l = badOptions.length; b < l; b++) {
					delete overrideOptions[badOptions[b]];
				}

				return overrideOptions;
			}
		}

		function createToastEl(scope) {
			var angularDomEl = angular.element('<div toast-drt></div>'),
				$compile = $injector.get('$compile');
			return $compile(angularDomEl)(scope);
		}

		function maxOpenedNotReached() {
			return (options.maxOpened && toasts.length <= options.maxOpened) || !options.maxOpened;
		}

		function shouldExit() {
			var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
			var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];

			if (isDuplicateOfLast || isDuplicateOpen) {
				return true;
			}

			previousToastMessage = map.message;
			openToasts[map.message] = true;

			return false;
		}
	}
}

function progressBar(toastrConfig, $interval) {
	return {
		require: '^toast',
		templateUrl: function () {
			return toastrConfig.templates.progressbar;
		},
		link: linkFunction,
	};

	function linkFunction(scope, element, attrs, toastCtrl) {
		var intervalId, currentTimeOut, hideTime;

		toastCtrl.progressBar = scope;

		scope.start = function (duration) {
			if (intervalId) {
				$interval.cancel(intervalId);
			}

			currentTimeOut = parseFloat(duration);
			hideTime = new Date().getTime() + currentTimeOut;
			intervalId = $interval(updateProgress, 10);
		};

		scope.stop = function () {
			if (intervalId) {
				$interval.cancel(intervalId);
			}
		};

		function updateProgress() {
			var percentage = ((hideTime - new Date().getTime()) / currentTimeOut) * 100;
			element.css('width', percentage + '%');
		}

		scope.$on('$destroy', function () {
			// Failsafe stop
			$interval.cancel(intervalId);
		});
	}
}

function ToastController() {
	this.progressBar = null;

	this.startProgressBar = function (duration) {
		if (this.progressBar) {
			this.progressBar.start(duration);
		}
	};

	this.stopProgressBar = function () {
		if (this.progressBar) {
			this.progressBar.stop();
		}
	};
}

function directiveToast($injector, $interval, toastrConfig, toastr) {
	return {
		templateUrl: function () {
			return toastrConfig.templates.toast;
		},
		controller: 'ToastController',
		link: toastLinkFunction,
	};

	function toastLinkFunction(scope, element, attrs, toastCtrl) {
		var timeout;

		scope.toastClass = scope.options.toastClass;
		scope.titleClass = scope.options.titleClass;
		scope.messageClass = scope.options.messageClass;
		scope.progressBar = scope.options.progressBar;
		scope.iconName = resolveIconName(scope.toastType);

		if (wantsCloseButton()) {
			var button = angular.element(scope.options.closeHtml),
				$compile = $injector.get('$compile');
			button.addClass('toast-close-button');
			button.attr('ng-click', 'close(true, $event)');
			$compile(button)(scope);
			element.children().prepend(button);
		}

		scope.init = function () {
			if (scope.options.timeOut) {
				timeout = createTimeout(scope.options.timeOut);
			}
			if (scope.options.onShown) {
				scope.options.onShown();
			}
		};

		element.on('mouseenter', function () {
			hideAndStopProgressBar();
			if (timeout) {
				$interval.cancel(timeout);
			}
		});

		scope.tapToast = function () {
			if (typeof scope.options.onTap === 'function') {
				scope.options.onTap();
			}
			if (scope.options.tapToDismiss) {
				scope.close(true);
			}
		};

		scope.close = function (wasClicked, $event) {
			if ($event && typeof $event.stopPropagation === 'function') {
				$event.stopPropagation();
			}
			toastr.remove(scope.toastId, wasClicked);
		};

		scope.refreshTimer = function (newTime) {
			if (timeout) {
				$interval.cancel(timeout);
				timeout = createTimeout(newTime || scope.options.timeOut);
			}
		};

		element.on('mouseleave', function () {
			if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) {
				return;
			}
			scope.$apply(function () {
				scope.progressBar = scope.options.progressBar;
			});
			timeout = createTimeout(scope.options.extendedTimeOut);
		});

		function createTimeout(time) {
			toastCtrl.startProgressBar(time);
			return $interval(
				function () {
					toastCtrl.stopProgressBar();
					toastr.remove(scope.toastId);
				},
				time,
				1
			);
		}

		function hideAndStopProgressBar() {
			scope.progressBar = false;
			toastCtrl.stopProgressBar();
		}

		function wantsCloseButton() {
			return scope.options.closeHtml;
		}

		// Map the toast type class (e.g. 'toast-error') to an svg-icon asset name
		// using the configured iconClasses -> iconNames pairing.
		function resolveIconName(toastType) {
			var iconClasses = toastrConfig.iconClasses || {};
			var iconNames = toastrConfig.iconNames || {};
			var typeKey = Object.keys(iconClasses).find(function (key) {
				return iconClasses[key] === toastType;
			});
			return typeKey ? iconNames[typeKey] : null;
		}
	}
}

export default (mod = mod.name);
